import { ref } from 'vue'

/** @typedef {'success'|'warning'|'error'|'info'} ToastType */

/** @type {import('vue').Ref<Array<{ id: string, type: ToastType, message: string, title?: string, variant: 'message'|'notification' }>>} */
export const appToastItems = ref([])

let toastSeq = 0

/**
 * @param {{ type?: ToastType, message: string, title?: string, variant?: 'message'|'notification', duration?: number }} payload
 */
export function pushAppToastItem(payload) {
  const message = String(payload?.message ?? '').trim()
  if (!message) return null
  const id = `toast-${++toastSeq}`
  const item = {
    id,
    type: payload.type || 'info',
    message,
    title: payload.title,
    variant: payload.variant || 'message',
  }
  appToastItems.value = [...appToastItems.value, item]
  const duration = payload.duration ?? (item.variant === 'notification' ? 5200 : 4500)
  if (duration > 0) {
    setTimeout(() => dismissAppToastItem(id), duration)
  }
  return id
}

export function dismissAppToastItem(id) {
  appToastItems.value = appToastItems.value.filter((t) => t.id !== id)
}

export function clearAppToastItems() {
  appToastItems.value = []
}
